module.exports = __webpack_public_path__ + "img/logo_l3af.855ccbd.png";